import { WhereClauseWithCompoundExpression } from "../ars_ldm";
import { isLevelOrder } from "./isLevelOrder";
import { isObjectRecord } from "./isObjectRecord";
import { isWhereClauseCompoundExpression } from "./isWhereClauseCompoundExpression";

/**
 * Type guard to check if a value is a WhereClauseWithCompoundExpression.
 *
 * @param obj - The value to check
 * @returns True if the value is a WhereClauseWithCompoundExpression
 */
export const isWhereClauseWithCompoundExpression = (
  obj: unknown,
): obj is WhereClauseWithCompoundExpression => {
  if (!isObjectRecord(obj)) return false;
  const objectRecord = obj;
  // Check basic structure
  if (!isLevelOrder(obj)) return false;

  // Must have a valid compoundExpression
  if (!isWhereClauseCompoundExpression(objectRecord.compoundExpression)) return false;

  // Must not have condition property
  if (objectRecord.condition !== undefined) return false;

  return true;
};
